import React from 'react'
import { connect } from 'react-redux';
import { Layout, PageHeader, ProductList, Footer, LottieLoadingView } from '../components'

const products = (props) => {
    return (
        <Layout>
            <PageHeader fontSize={14} fontFamily={'AmanticBold'} background={'#FF8700'} color={'white'} height={5} headercenter={'PRODUCTS'} subheader={'Click on each product to learn about its nutrition facts and new flavor boost!'} />
            {props.loading ? <LottieLoadingView /> : <ProductList />}
            <Footer />
        </Layout>
    )
}

export default connect((state) => ({ loading: state.getProductsLoading }))(products);